export enum enumPaymentStatus {
    PROCESSING = 1,
    PAYED = 2,
    NOT_PAYED = 3,
}


// const paymentStatusMap = new Map<enumPaymentStatus, string>([
//     [enumPaymentStatus.PROCESSING, 'In verifica'],
//     [enumPaymentStatus.PAYED, 'Pagato'],
//     [enumPaymentStatus.NOT_PAYED, 'Non pagato'],
//   ]);
  
//   export const getPaymentStatusNameById = (name: string) => [...paymentStatusMap].find(([key, value]) => name === value)![0];